import(/* webpackMode: "eager" */ "/tour/app/global-error.tsx");
